import { FC, useState } from "react";

import AddNote from "../modals/addNote";

import { KamFamNoteProps } from "./types";
import { getDateTimeFormat } from "src/helpers/dateTime";



const KAMFAMNotes: FC<KamFamNoteProps> = ({ caseId, kamfamNotes, add_note, drug_name, isPatient, updateKamfamNotes }): JSX.Element => {
  const [isNoteModalVisible, setNoteModalVisibility] = useState<boolean>(false);

  return (
    <div className="card">
      <div className={`card-header ${isPatient ? "" : drug_name === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
        <div className="d-flex justify-content-between align-items-center">
          <h4 className="mb-0">Case {caseId} AM/FRM Notes</h4>
          {add_note && (
            <button className="btn btn-success btn-sm text-nowrap" onClick={() => setNoteModalVisibility(true)}>Add Note</button>
          )}
        </div>
      </div>
      <div className="card-body">
          {kamfamNotes.length > 0 &&
              kamfamNotes.map((item, index) => (
                  <div className={`mb-2 py-2 px-3 rounded-3 ${index % 2 === 0 ? 'bg-primary-light' : ''}`} key={index}>
                      <div className="row">
                          <div className="col-12 col-md-3">
                              <h6 className="mb-1">{item ? item.name || item.user_fullname || item.user || "" : ""}</h6>
                              <small className="d-flex align-items-center">
                                  {/* <i className="bi bi-clock"></i>&nbsp; {item ? getDateTimeFormat(item?.created_at) || (item.date && getDateTimeFormat(item.date)) : ''} */}
                                  <i className="bi bi-clock"></i>&nbsp; {item ? getDateTimeFormat(item.created_at || "") || getDateTimeFormat(item.date || "") : ''}
                              </small>
                          </div>
                          <div className="col-12 col-md-9">
                              <p className="m-0">{item ? item.description : ''}</p>
                          </div>
                      </div>
                  </div>
              ))
          }
      </div>

      <AddNote
        isModalVisible={isNoteModalVisible}
        caseId={caseId}
        refreshListing={(note) => updateKamfamNotes((oldNote) => ([note, ...oldNote]))}
        hideModal={() => setNoteModalVisibility(false)}
      />
    </div>
  )
}

export default KAMFAMNotes;
